import { Component, Injector, ViewEncapsulation, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {
    WebShopServiceProxy,
    CategoryDto,
    OrderGuideSimpleDto,
    BasketArticleDto,
    ArticleDto,
    PagedResultDtoOfFavoriteArticleDto
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';

import { throwError, Subscription } from 'rxjs';

import { appModuleAnimation } from '@axilla/axilla-shared';
import _ from 'lodash-es';
import { take, finalize } from 'rxjs/operators';

import { Table } from 'primeng/table';
import { Paginator } from 'primeng/paginator';
import { LazyLoadEvent, SelectItem, MenuItem } from 'primeng/api';

import { WebshopService } from '@app/shared/common/shop-system/services/webshop.service';
import { AppConsts } from '@shared/AppConsts';
import { WebshopItemDetailsModalComponent } from '@app/webshop/shop/webshop-item-details-modal.component';

@Component({
    templateUrl: './favorites.component.html',
    styleUrls: ['../dashboard/dashboard.component.less', './favorites.component.less'],
    animations: [appModuleAnimation()]
})
export class FavoritesComponent extends AppComponentBase implements OnInit, OnDestroy {
    @ViewChild('webshopItemDetails', { static: false }) webshopItemDetailsModal: WebshopItemDetailsModalComponent;

    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    set orderGuide(value: OrderGuideSimpleDto) {
        this._orderGuide = value;
    }
    get orderGuide() {
        return this._orderGuide;
    }
    set category(value: CategoryDto) {
        this._category = value;
    }
    get category() {
        return this._category;
    }
    get favoritesArticle(): BasketArticleDto[] {
        return this._webshopService.favoritesArticle;
    }

    private _favoritesItemsCount = 0;

    get favoritesItemsCount(): number {
        return this._favoritesItemsCount;
    }

    set favoritesItemsCount(count: number) {
        this._favoritesItemsCount = count;
    }

    orderGuideId: string;
    categoryId: string;

    private _orderGuide: OrderGuideSimpleDto;

    private _category: CategoryDto;
    isLoading = false;

    filter = '';

    changeRouter$: Subscription;

    products: BasketArticleDto[];

    sortOptions: SelectItem[];

    sortKey = '';
    rowsAmount = 9;
    isCategoryMode = false;

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    navItems: MenuItem[];

    home: MenuItem;
    //#endregion Getting data


    //#region search form related fields
    webshopCode: any;
    webshopTitle: any;

    typingTimer: any;
    doneTypingInterval = 500;

    favoritesCounterUpdatetSubscription$;

    constructor(
        injector: Injector,

        private webShopServiceProxy: WebShopServiceProxy,
        private _router: Router,

        private _webshopService: WebshopService
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.sortOptions = [
            { label: 'Sort by relevance', value: 'relevance' },
            { label: 'Price (high to low)', value: '!price' },
            { label: 'Price (low to high)', value: 'price' }
        ];

        this.home = { icon: 'pi pi-home', url: 'app/webshop/dashboard' };

        if (this.isOuBlocked) {
            this.showIsBlockedMessage();
        } else {
            this.checkIsOuBlocked();
        }

        this._onFavoritesUpdate();
    }

    ngOnDestroy(): void {

    }


    private _onFavoritesUpdate() {
        this.favoritesCounterUpdatetSubscription$ = this._webshopService.favoritesCounterUpdate$
            .subscribe((count: number) => {
                this.favoritesItemsCount = count;
            });
    }

    openDetails(item: any) {
        let article = (item.data ?? item) as ArticleDto;
        this.webShopServiceProxy.getArticle(article.id).subscribe();

        this.webshopItemDetailsModal.show(item);
    }

    //#region Getting data

    loadData(event?: LazyLoadEvent) {
        this.isLoading = true;

        this._loadFavorites(event);
    }

    private _loadFavorites(event?: LazyLoadEvent) {
        this.isLoading = true;

        this._webshopService.getFavorites$(this.webshopCode, event)
            .pipe(
                take(1),
                finalize(() => { this.isLoading = false; })
            )
            .subscribe((result: PagedResultDtoOfFavoriteArticleDto) => {
                this.isLoading = false;
            });
    }

    searchAndLoadData(data: any) {
        let event = data.event || null;

        this.webshopCode = data.webshopCode;
        this.webshopTitle = data.webshopTitle;

        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.loadData.bind(this, event), this.doneTypingInterval);
    }
    //#endregion search form related fields

    goToBasket() {
        this._router.navigate(['/app/webshop/basket-overview']);
    }

    private _addItemToBasket(article: BasketArticleDto) {
        if (+article.quantity <= 0 || article.quantity === undefined) {
            return throwError('Item quantity = 0, change ');
        }

        const item = _.cloneDeep(article);
        this._webshopService.addItem(item);
        this.resetQuantity(article);
    }

    addToBasket($event: Event, article: BasketArticleDto) {
        this._addItemToBasket(article);

    }
    preventClick($event: Event) {
        $event.stopPropagation();
    }

    resetQuantity(article: BasketArticleDto) {
        article.quantity = 0;
    }

}

